<template>
  <div>
    <cabecalho-pagina
      :titulo="$t('modulos.importacao.titulos.listagem')"
      :total-registros="tabela.quantidadeItens"
      :sem-filtro="true"
      :sem-botao-ok="true"
      :tem-tags="true"
      :valor-tags="badges"
    />
    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="tabela.selecionados"
      :dados="tabela.dados"
      class="mt-2"
      filtros-com-colunas
      filtro-global-focus
      :colunas="tabela.colunas"
      :por-pagina="tabela.porPagina"
      :quantidade-itens="tabela.quantidadeItens"
      :quantidade-paginas="tabela.quantidadePaginas"
      :mostrar-seletor="false"
      :mostrar-acoes="false"
      @paginar="buscarDadosImportacao"
      @filtrarGlobal="buscarDadosImportacao"
      @filtroGlobal="(v) => (filtroAplicado.filter = v)"
    />
    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao
        outlined
        color="secondary"
        class="mr-2"
        @click="voltar"
      >
        <v-icon>$mdiArrowLeft</v-icon>
        {{ $t('geral.botoes.voltar') }}
      </botao-padrao>
    </div>
  </div>
</template>
  
<script>
import { ImportacaoService } from '../../../../common/services/cadastros';
import CabecalhoPagina from '@components/layout/CabecalhoPagina.vue';
import helpers from '@common/utils/helpers';

export default {
    components: {
        CabecalhoPagina,
    },
    props: {
        id: { type: String, default: '' },
    },
    data() {
        return {
            tabela: {
                selecionados: [],
                dados: [],
                colunas: [
                    {
                        value: 'descricao',
                        text: this.$t('modulos.importacao.tabela.descricao'),
                        sortable: false,
                    },
                    {
                        value: 'numeroLinha',
                        text: this.$t('modulos.importacao.tabela.numeroLinha'),
                        sortable: false,
                    },
                    {
                        value: 'tipo',
                        text: this.$t('modulos.importacao.tabela.situacao'),
                        sortable: false,
                    },
                ],
                quantidadeItens: 0,
                quantidadePaginas: 0,
                paginaAtual: 1,
                porPagina: 10,
            },

            filtroAplicado: { filter: '' },
            colunaOrdenada: '',
            badges: [],
        };
    },
    mounted() {
        this.$store.dispatch(
            'Layout/alterarTituloPagina',
            this.$t('modulos.importacao.titulos.listagem')
        );
        this.buscarDadosImportacao();
        this.buscarDadosBadges();
        console.log(this.badges);
    },
    methods: {
        buscarDadosImportacao(
            paginaAtual = this.tabela.paginaAtual,
            porPagina = this.tabela.porPagina
        ) {
            this.tabela.porPagina = porPagina;
            const parametros = {
                page: paginaAtual,
                amountPerPage: porPagina,
                ...helpers.formattingParameters(this.filtroAplicado),
            };
            this.$store.dispatch('Layout/iniciarCarregamento');
            ImportacaoService.buscaPorId(this.id, parametros)
                .then((res) => {
                    this.tabela.dados = res.data.items;
                    this.tabela.quantidadeItens = res.data.totalItems;
                    this.tabela.quantidadePaginas = res.data.totalPages;
                    this.tabela.paginaAtual = paginaAtual;
                    this.tabela.porPagina = porPagina;
                })
                .finally(() => {
                    this.$store.dispatch('Layout/terminarCarregamento');
                });
        },
        buscarDadosBadges() {
            const id = this.$route.params.id;
            this.$store.dispatch('Layout/iniciarCarregamento');

            ImportacaoService.listar()
                .then((res) => {
                    const item = res.data.items.find(item => item.id === id);
                    this.badges = [
                        { [this.$t('modulos.importacao.tabela.data')]: helpers.formatarDataBr(item?.data, true) },
                        { [this.$t('modulos.importacao.tabela.cliente')]: item?.participante?.descricao },
                        { [this.$t('modulos.importacao.tabela.tipoArquivo')]: item?.entidadeImportacao },
                        { [this.$t('modulos.importacao.tabela.tipoImportacao')]: item?.tipo },
                        { [this.$t('modulos.importacao.tabela.situacao')]: item?.statusProcessamento },
                    ];
                })
                .finally(() => {
                    this.$store.dispatch('Layout/terminarCarregamento');
                });
        },
        voltar: function () {
            this.$router.push({ name: 'importacao' })
        },
    },
};
</script>